import axios from "axios";
import { waitForFirebaseUser } from "./firebaseAuthHelper";

const API_BASE = "https://modularobjects.com/mailserver/api/interior";

async function authConfig() {
  const user = await waitForFirebaseUser();
  const token = await user.getIdToken();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
}

const interiorCatalogApi = {
  async listAssets(params = {}) {
  const config = await authConfig();

  const { data } = await axios.get(`${API_BASE}/assets`, {
    ...config,
    params,
  });

  return data;
},

  async getAssetById(id) {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/assets/${id}`, config);
    return data;
  },

  async getAssetStatus(id) {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/assets/${id}/status`, config);
    return data;
  },

  async uploadAsset({ file, code, name }) {
    const config = await authConfig();

    const formData = new FormData();
    formData.append("file", file);
    formData.append("code", code || "");
    formData.append("name", name || "");

    const { data } = await axios.post(`${API_BASE}/assets/upload`, formData, {
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  },

  async bulkUploadAssets(formData) {
  const config = await authConfig();
  const { data } = await axios.post(
    `${API_BASE}/assets/bulk-upload`,
    formData,
    {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
},

  async listFamilies(params = {}) {
  const config = await authConfig();

  const { data } = await axios.get(`${API_BASE}/families`, {
    ...config,
    params,
  });

  return data;
},

  async createFamily(payload) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/families`, payload, config);
    return data;
  },

  async updateFamily(id, payload) {
    const config = await authConfig();
    const { data } = await axios.put(`${API_BASE}/families/${id}`, payload, config);
    return data;
  },

  async deleteFamily(id) {
    const config = await authConfig();
    const { data } = await axios.delete(`${API_BASE}/families/${id}`, config);
    return data;
  },

  async listFamilyItems(params = {}) {
  const config = await authConfig();

  const { data } = await axios.get(`${API_BASE}/family-items`, {
    ...config,
    params: {
      status: "active",
      ...params,
    },
  });

  return data;
},

async getFamilyItemById(id) {
  const config = await authConfig();

  const { data } = await axios.get(`${API_BASE}/family-items/${id}`, config);

  return data;
},

  async createFamilyItem(payload) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/family-items`, payload, config);
    return data;
  },

  async updateFamilyItem(id, payload) {
    const config = await authConfig();
    const { data } = await axios.put(`${API_BASE}/family-items/${id}`, payload, config);
    return data;
  },

  async deleteFamilyItem(id) {
    const config = await authConfig();
    const { data } = await axios.delete(`${API_BASE}/family-items/${id}`, config);
    return data;
  },

  async listItemAssets(itemId) {
  const config = await authConfig();

  const { data } = await axios.get(
    `${API_BASE}/family-items/${itemId}/components`,
    config
  );

  return data;
},

async createItemAsset(itemId, payload) {
  const config = await authConfig();

  const { data } = await axios.post(
    `${API_BASE}/family-items/${itemId}/components`,
    payload,
    config
  );

  return data;
},

async addAssetAsItemComponent(itemId, payload) {
  const config = await authConfig();

  const { data } = await axios.post(
    `${API_BASE}/family-items/${itemId}/components/from-asset`,
    payload,
    config
  );

  return data;
},

async updateItemAsset(id, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/item-assets/${id}`,
    payload,
    config
  );

  return data;
},

async deleteItemAsset(id) {
  const config = await authConfig();

  const { data } = await axios.delete(
    `${API_BASE}/item-assets/${id}`,
    config
  );

  return data;
},

  async listItemMountings() {
    const config = await authConfig();
    const { data } = await axios.get(`${API_BASE}/item-mountings`, config);
    return data;
  },

  async createItemMounting(payload) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/item-mountings`, payload, config);
    return data;
  },

  async updateItemMounting(id, payload) {
    const config = await authConfig();
    const { data } = await axios.put(`${API_BASE}/item-mountings/${id}`, payload, config);
    return data;
  },

  async deleteItemMounting(id) {
    const config = await authConfig();
    const { data } = await axios.delete(`${API_BASE}/item-mountings/${id}`, config);
    return data;
  },

    async duplicateFamily(id) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/families/${id}/duplicate`, {}, config);
    return data;
  },

  async duplicateFamilyItem(id) {
    const config = await authConfig();
    const { data } = await axios.post(`${API_BASE}/family-items/${id}/duplicate`, {}, config);
    return data;
  },

  async getAssetUsage(id) {
  const config = await authConfig();
  const { data } = await axios.get(`${API_BASE}/assets/${id}/usage`, config);
  return data;
},

async listCategories(params = {}) {
  const config = await authConfig();

  const { data } = await axios.get(`${API_BASE}/categories`, {
    ...config,
    params,
  });

  return data;
},

async listParameterDefinitions(params = {}) {
  const config = await authConfig();

  const { data } = await axios.get(`${API_BASE}/parameters/definitions`, {
    ...config,
    params,
  });

  return data;
},

async getAssetMounting(assetId) {
  const config = await authConfig();

  const { data } = await axios.get(
    `${API_BASE}/assets/${assetId}/mounting`,
    config
  );

  return data;
},

async createAssetMounting(assetId, payload) {
  const config = await authConfig();

  const { data } = await axios.post(
    `${API_BASE}/assets/${assetId}/mounting`,
    payload,
    config
  );

  return data;
},

async updateAssetMounting(id, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/asset-mountings/${id}`,
    payload,
    config
  );

  return data;
},

async listItemFiles(itemId) {
  const config = await authConfig();

  const { data } = await axios.get(
    `${API_BASE}/family-items/${itemId}/files`,
    config
  );

  return data;
},

async uploadItemFile(itemId, { file, file_role, file_label }) {
  const config = await authConfig();

  const formData = new FormData();
  formData.append("file", file);
  formData.append("file_role", file_role || "document");
  formData.append("file_label", file_label || "");

  const { data } = await axios.post(
    `${API_BASE}/family-items/${itemId}/files/upload`,
    formData,
    {
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
},

async updateItemFile(itemId, fileId, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/family-items/${itemId}/files/${fileId}`,
    payload,
    config
  );

  return data;
},

async deleteItemFile(itemId, fileId) {
  const config = await authConfig();

  const { data } = await axios.delete(
    `${API_BASE}/family-items/${itemId}/files/${fileId}`,
    config
  );

  return data;
},

async listAssetMountingItems(assetMountingId) {
  const config = await authConfig();

  const { data } = await axios.get(
    `${API_BASE}/asset-mountings/${assetMountingId}/items`,
    config
  );

  return data;
},

async addAssetMountingItem(assetMountingId, payload) {
  const config = await authConfig();

  const { data } = await axios.post(
    `${API_BASE}/asset-mountings/${assetMountingId}/items`,
    payload,
    config
  );

  return data;
},

async listItemMountingItems(itemMountingId) {
  const config = await authConfig();

  const { data } = await axios.get(
    `${API_BASE}/item-mountings/${itemMountingId}/items`,
    config
  );

  return data;
},

async addItemMountingItem(itemMountingId, payload) {
  const config = await authConfig();

  const { data } = await axios.post(
    `${API_BASE}/item-mountings/${itemMountingId}/items`,
    payload,
    config
  );

  return data;
},

async updateMountingItem(id, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/mounting-items/${id}`,
    payload,
    config
  );

  return data;
},

async deleteMountingItem(id) {
  const config = await authConfig();

  const { data } = await axios.delete(
    `${API_BASE}/mounting-items/${id}`,
    config
  );

  return data;
},

async getDefinitionHardwareSetup(definitionId) {
  const config = await authConfig();
  const { data } = await axios.get(
    `${API_BASE}/definitions/${definitionId}/hardware-setup`,
    config
  );
  return data;
},

async updateDefinitionDefaultParameters(definitionId, defaultParameters) {
  const config = await authConfig();
  const { data } = await axios.put(
    `${API_BASE}/definitions/${definitionId}/default-parameters`,
    { default_parameters: defaultParameters },
    config
  );
  return data;
},

async loadDefinitionParametersFromLinkedItem(definitionId) {
  const config = await authConfig();
  const { data } = await axios.post(
    `${API_BASE}/definitions/${definitionId}/load-parameters-from-linked-item`,
    {},
    config
  );
  return data;
},

async linkDefinitionCatalogItem(definitionId, catalogItemId) {
  const config = await authConfig();
  const { data } = await axios.put(
    `${API_BASE}/definitions/${definitionId}/link-catalog-item`,
    { catalog_item_id: catalogItemId },
    config
  );
  return data;
},

async applyRunnerFormulas(definitionId) {
  const config = await authConfig();
  const { data } = await axios.post(
    `${API_BASE}/definitions/${definitionId}/apply-runner-formulas`,
    {},
    config
  );
  return data;
},

async updateDefinitionComponentAssetMountingReferenceFrame(
  definitionId,
  mountingId,
  payload
) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/definitions/${definitionId}/component-asset-mountings/${mountingId}/reference-frame`,
    payload,
    config
  );

  return data;
},

async updateDefinitionLinkedItemMountingReferenceFrame(definitionId, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/definitions/${definitionId}/linked-item-mounting/reference-frame`,
    payload,
    config
  );

  return data;
},

async updateDefinitionLinkedItemMountingPlacementRules(definitionId, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/definitions/${definitionId}/linked-item-mounting/placement-rules`,
    payload,
    config
  );

  return data;
},

async clearDefinitionComponentLocalParameters(definitionId, itemAssetId) {
  const config = await authConfig();

  const { data } = await axios.post(
    `${API_BASE}/definitions/${definitionId}/component-links/${itemAssetId}/clear-local-parameters`,
    {},
    config
  );

  return data;
},

async updateDefinitionComponentMetadata(definitionId, itemAssetId, payload) {
  const config = await authConfig();

  const { data } = await axios.put(
    `${API_BASE}/definitions/${definitionId}/component-links/${itemAssetId}/metadata`,
    payload,
    config
  );

  return data;
},

async getItemMountingByItemId(itemId) {
  const config = await authConfig();

  const { data } = await axios.get(
    `${API_BASE}/family-items/${itemId}/mounting`,
    config
  );

  return data;
},
};

export default interiorCatalogApi;